/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type ChannelReviewStatus = typeof ChannelReviewStatus[keyof typeof ChannelReviewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
